import { Link as RouterLink } from 'react-router-dom'
import { Text } from '@cloudflare/kumo'
import type { RecentGuest } from '@hub-wifi/shared'
import { useTranslation } from '../../i18n'
import { initials } from './agenda'
import { onPlainClick } from './plain-click'

const MAX_CHIPS = 6

export interface InviteAgainProps {
  guests: RecentGuest[]
  /** Open the Invite sheet pre-filled instead of navigating. */
  onInvite?: (guest: RecentGuest) => void
}

/**
 * Recent guests as chips. A chip opens the Invite sheet pre-filled (`onInvite`);
 * its href, `/my/guests/new?guest=<email>`, pre-fills the full form and stays
 * as the fallback.
 */
export function InviteAgain({ guests, onInvite }: InviteAgainProps) {
  const { t } = useTranslation()
  if (guests.length === 0) return null

  return (
    <section aria-labelledby="home-invite-again" className="flex flex-col gap-3">
      <Text as="h2" variant="heading3" id="home-invite-again">
        {t('dashboard.inviteAgain.title')}
      </Text>
      <ul className="home-chips">
        {guests.slice(0, MAX_CHIPS).map((guest) => (
          <li key={guest.guestEmail}>
            <RouterLink
              to={`/my/guests/new?guest=${encodeURIComponent(guest.guestEmail)}`}
              onClick={onPlainClick(onInvite && (() => onInvite(guest)))}
              className="home-chip"
              aria-label={t('dashboard.inviteAgain.invite', { name: guest.guestName })}
            >
              <span className="home-avatar home-avatar--sm" aria-hidden>
                {initials(guest.guestName)}
              </span>
              <span className="truncate">{guest.guestName}</span>
            </RouterLink>
          </li>
        ))}
      </ul>
    </section>
  )
}
